import * as Yup from "yup";

export const createTeamSchema = Yup.object().shape({
  team_name: Yup.string().required("Team name is required"),
  country: Yup.string().required("Please select a country"),
});

export const editTeamSchema = Yup.object().shape({
  team_name: Yup.string().required("Team name is required"),
  country: Yup.string().required("Please select a country"),
});

export const addTeamMemberSchema = Yup.object().shape({
  team_id: Yup.string().required("Team name is required"),
  role_id: Yup.string().required("role name is required"),
  user_id: Yup.string().required("user name is required"),
});
